import { render, staticRenderFns } from "./DrawerPA.vue?vue&type=template&id=4bc370bf&scoped=true&"
import script from "./DrawerPA.vue?vue&type=script&lang=js&"
export * from "./DrawerPA.vue?vue&type=script&lang=js&"
import style0 from "./DrawerPA.vue?vue&type=style&index=0&id=4bc370bf&scoped=true&lang=css&"
import style1 from "./DrawerPA.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc370bf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bc370bf')) {
      api.createRecord('4bc370bf', component.options)
    } else {
      api.reload('4bc370bf', component.options)
    }
    module.hot.accept("./DrawerPA.vue?vue&type=template&id=4bc370bf&scoped=true&", function () {
      api.rerender('4bc370bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientDashboard/workspace/productEngagement/SignAgreement/DrawerPA.vue"
export default component.exports